import { render, staticRenderFns } from "./AlteracoesListItem.vue?vue&type=template&id=e3f2b558&scoped=true&"
import script from "./AlteracoesListItem.vue?vue&type=script&lang=js&"
export * from "./AlteracoesListItem.vue?vue&type=script&lang=js&"
import style0 from "./AlteracoesListItem.vue?vue&type=style&index=0&id=e3f2b558&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3f2b558",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VListItem,VListItemContent})
